import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { FaArrowRightLong, FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { AiFillFilePdf } from "react-icons/ai";
import { FaCircleArrowUp } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import ScrollToTop from "../../components/scrollToTop/scrollToTop";
import axios from "axios";
import DOMPurify from "dompurify"; // 1. IMPORTAR DOMPURIFY
import cuadroAzul from "../../assets/imgs/preguntas-frecuentes/cuadro_azul_texto.png";
import "./freq-questions.css";
import airBannerImg from "../../assets/imgs/preguntas-frecuentes/air.jpg";

// Función auxiliar para sanitizar URLs de descarga
const sanitizeDownloadUrl = (url) => {
  if (!url || typeof url !== "string") return "#";
  const trimmed = url.trim();
  const isSafeProtocol = /^(https?:\/\/|\/|\.\/)/i.test(trimmed);
  const isDangerous = /^(javascript|data|vbscript):/i.test(trimmed);

  if (isSafeProtocol && !isDangerous) {
    return DOMPurify.sanitize(trimmed);
  }
  return "#";
};

// Función auxiliar para sanitizar marcado HTML seguro
const createSafeHtml = (htmlContent) => {
  const content = htmlContent || "No hay respuestas disponibles";
  return {
    __html: DOMPurify.sanitize(content)
  };
};

function FrequentlyQuestions() {
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedSection, setSelectedSection] = useState("Nacional");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [OpenDropdownIndex, setOpenDropdownIndex] = useState(0);
  const [categoria, setCategoria] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [pregunta, setPregunta] = useState([]);
  const [tFreqQuestions] = useTranslation("freq_questions");
  const [tSMetaDataFaqs] = useTranslation("metaData");
  const lng = localStorage.getItem("lng") || "es";

  let storedLang = lng === "us" ? "en" : "es";
  const endpointUrl = `${process.env.REACT_APP_URL_BACKEND}/api/qfa/issues/lang/${encodeURIComponent(storedLang)}`;
  sessionStorage.setItem("routeEs", `/faqs`);
  sessionStorage.setItem("routeEn", `/faqs`);

  useEffect(() => {
    axios
      .get(endpointUrl)
      .then((response) => {
        if (response.data.code === 1) {
          setCategoria(response.data.data);
          if (response.data.data.length > 0) {
            setSelectedSection(response.data.data[0].name);
            handleSectionCategoryChange(response.data.data[0]);
          }
        }
      })
      .catch((error) => {
        console.log("Error al obtener los datos de los botones:", error);
      });
  }, [storedLang]);

  // Segundo endpoint para Categorias
  const handleSectionCategoryChange = async (item) => {
    setSelectedSection(item.name);
    const safeLang = encodeURIComponent(storedLang);
    const safeId = encodeURIComponent(String(item.id));
    const endpointUrlCategoria = `${process.env.REACT_APP_URL_BACKEND}/api/qfa/category/forLevel/${safeLang}/${safeId}`;
    try {
      const response = await axios.get(endpointUrlCategoria);
      setSubcategory(response.data.data || []);

      if (response.data.data.length > 0) {
        setSelectedCategory(response.data.data[0].id);
        handleCategoryAndQuestionClick(response.data.data[0]);
      }
    } catch (error) {
      console.log("No hay datos para mostrar");
      setSubcategory([]);
    }
  };

  // Tercer endpoint para Pregunta
  const handleCategoryAndQuestionClick = async (item) => {
    setSelectedCategory(item.id);
    const safeLang = encodeURIComponent(storedLang);
    const safeId = encodeURIComponent(String(item.id));
    const endpointUrlPregunta = `${process.env.REACT_APP_URL_BACKEND}/api/qfa/question/forLevel/${safeLang}/${safeId}`;
    try {
      const response = await axios.get(endpointUrlPregunta);
      setPregunta(response.data.data || []);
      setOpenDropdownIndex(null);
    } catch (error) {
      console.log("Error al hacer la conexion al endpoint");
      setPregunta([]);
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleDropdown = (index) => {
    setOpenDropdownIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <ScrollToTop />
      <Helmet>
        <title>{tSMetaDataFaqs("preguntasFrecuentes.title")}</title>
        <meta
          name="description"
          content={tSMetaDataFaqs("preguntasFrecuentes.description")}
        ></meta>
      </Helmet>
      <Navbar />

      <h1 className="faq-page-h1">
        {tSMetaDataFaqs("preguntasFrecuentes.title")}
      </h1>

      <section className="primeraSeccion">
        <div className="bgAirplaneSky">
          <img className="airBg" src={airBannerImg} alt="Air Banner" />
          <div className="contenido">
            <img src={cuadroAzul} alt="imagen-fondo-azul-Preguntas-Frecuentes" />
          </div>
        </div>
      </section>

      <section className="segundaSeccion">
        <div className="botones-container">
          {categoria.map((item, index) => (
            <button
              key={index}
              className={`botonGral ${
                selectedSection === item.name ? "active" : ""
              }`}
              onClick={() => handleSectionCategoryChange(item)}
            >
              {item.name}
            </button>
          ))}
        </div>
      </section>

      <section className="terceraSeccion">
        <div className="columnas-container">
          <div className="columna1">
            <h2>
              {screenWidth <= 1024
                ? tFreqQuestions("categorias")
                : tFreqQuestions("selecciona_categoria")}
            </h2>
            <div className="dropdowns-container">
              {subcategory.map((item, index) => (
                <div
                  key={index}
                  className={`dropdownCat categoria ${
                    selectedCategory === item.id ? "active" : ""
                  }`}
                  onClick={() => handleCategoryAndQuestionClick(item)}
                >
                  {item.name} 
                  <FaArrowRightLong className="iconoRight" />
                </div>
              ))}
            </div>
          </div>

          <div className="columna2">
            <h2>
              {screenWidth <= 1024
                ? tFreqQuestions("pregunta")
                : tFreqQuestions("selecciona_pregunta")}
            </h2>

            <div className="dropdowns-container">
              {pregunta.map((item, index) => (
                <div key={index} className="dropdown-wrapper">
                  <div
                    className={`dropdownPre pregunta ${ OpenDropdownIndex === index ? "open" : ""}`}
                    onClick={() => toggleDropdown(index)}>
                    {item.question}
                    {OpenDropdownIndex === index ? (
                      <FaAngleUp />
                    ) : (
                      <FaAngleDown />
                    )}
                  </div>
                  {OpenDropdownIndex === index && (
                    <div className="dropdown-content">
                      <span className="no_mb px-3">
                        {Array.isArray(item.answers) ? (
                          item.answers.map((answer, i) => (
                            <p 
                              className="no_mb" 
                              key={i} 
                              dangerouslySetInnerHTML={createSafeHtml(answer)}
                            ></p>
                          ))
                        ) : (
                          <p 
                            className="no_mb" 
                            dangerouslySetInnerHTML={createSafeHtml(item.answers)}
                          ></p>
                        )}

                        {item.file_url && (
                          <a 
                            href={sanitizeDownloadUrl(item.file_url)} 
                            rel="noopener noreferrer" 
                            download 
                            target="_blank"
                          >
                            {tFreqQuestions("descargar_documento")}{" "}
                            <AiFillFilePdf/>
                          </a>
                        )}
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        <section className="cuartaSeccion">
          <div className="scroll-top-button" onClick={scrollToTop}>
            <FaCircleArrowUp size={35} />
          </div>
        </section>
      </section>

      <Footer />
    </>
  );
}

export default FrequentlyQuestions;